



















































































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { loadMessages, locale } from 'devextreme/localization'

interface ComponentData {
  tableHeight: string,
  loading: boolean

  ticketingArtList: any[]

  nummer: any
  status: any
  priority: any
  ANSortierung: any
  adressNummer: any
  adressSBName: any
  ticketingArt: any
  bezeichnung: any
  beschreibung: any
  verantwortlich: any
  externeReferenz: any
  externeReferenz2: any
  produkt: any
  verknupftMit: any
  externeReferenz3: any
  GSAnzeigen: any
  maxRecords: number
  ticketingList: any[]

  focusedRowKey: number
}

export default Vue.extend({
  name: 'TicketingSearchDialog',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,

      ticketingArtList: [],

      nummer: null,
      status: null,
      priority: null,
      ANSortierung: null,
      adressNummer: null,
      adressSBName: null,
      ticketingArt: null,
      bezeichnung: null,
      beschreibung: null,
      verantwortlich: null,
      externeReferenz: null,
      externeReferenz2: null,
      produkt: null,
      verknupftMit: null,
      externeReferenz3: null,
      GSAnzeigen: null,
      maxRecords: 500,
      ticketingList: [],

      focusedRowKey: -1,
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onKeyDown (e: any): void {
      if(e.event.key === "Enter") {
        const foundTicket: any | undefined = this.ticketingList.find((item: any) => item.id === this.focusedRowKey)
        if(foundTicket) {
          this.$emit('selectedTicket', foundTicket)
        }
      }
    },

    rowDblClick (event: any): void {
      this.$emit('selectedTicket', event.data)
    },

    onFocusedCellChanging (e: any) {
      e.isHighlighted = false
    },

    onFocusedRowChanged (e: any): void {
      this.focusedRowKey = e.component.option('focusedRowKey')
    },

    onSearchButtonClick (): void {
      this.ticketingList = []
      this.searchTickets()
    },

    async searchTickets (): Promise<void> {
      this.ticketingList = [
        { id: 1, eingereich: '09.01.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '20.01.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 2, eingereich: '10.02.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '28.02.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 3, eingereich: '12.02.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '28.02.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 4, eingereich: '18.02.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '19.02.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 5, eingereich: '15.03.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '18.03.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 6, eingereich: '01.04.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '10.04.2025', status: 'Assigned', prioritat: 'Normal' },
      ]

      if(this.ticketingList.length > 0) {
        //@ts-ignore
        this.$refs.dataGrid.instance.option("focusedRowIndex", -1);

        this.focusedRowKey = 0
        setTimeout(() => {
          //@ts-ignore
          this.$refs.dataGrid.instance.focus()
          this.focusedRowKey = this.ticketingList[0].id
        }, 100)
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  async mounted (): Promise<void> {
    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
